var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats"},[_c('new-customers',{attrs:{"qty":_vm.newcustomers}}),_vm._v(" "),_c('domicilied-customers',{attrs:{"qty":_vm.domiciliatedCustomers}}),_vm._v(" "),_c('active-customers',{attrs:{"qty":_vm.activecustomers}}),_vm._v(" "),_c('prospects',{attrs:{"qty":_vm.prospects}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ca2f014","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Dashboard/Stats.vue
// module id = 1922
// module chunks = 0